import { useEffect } from 'react';

const ADMIN_BAR = '#admin-nav';
const PROPERTY = '--os-nav-admin-height';
const BODY_CLASS = 'os-nav-admin-bar';

export function useAdminBarHeight(): void {
  useEffect(() => {
    const bar = document.querySelector<HTMLElement>(ADMIN_BAR);

    if (!bar || typeof ResizeObserver === 'undefined') return undefined;

    let published = '';
    const sync = () => {
      const height = `${bar.getBoundingClientRect().height}px`;

      if (height === published) return;

      published = height;
      document.body.style.setProperty(PROPERTY, height);
    };
    const observer = new ResizeObserver(sync);

    document.body.classList.add(BODY_CLASS);
    observer.observe(bar);
    sync();

    return () => {
      observer.disconnect();
      document.body.classList.remove(BODY_CLASS);
      document.body.style.removeProperty(PROPERTY);
    };
  }, []);
}
